import React from 'react';
import { TableCell, TableCellProps } from '@mui/material';

const PaddedCell: React.FC<TableCellProps> = ({ sx, ...rest }) => {
  return <TableCell sx={{ px: { xs: 3, sm: 4 }, ...sx }} {...rest}></TableCell>;
};

export default PaddedCell;
